import light from './light.json';
import dark from './dark.json';

export function SetTheme(key, language = "light") {
  switch(language.toLocaleLowerCase()) {
    case "light":
      return light[key];
    case "dark":
      return dark[key];
    default:
      return light[key];
  }
};
